<div class="update-signature">
  <div class="container-fluid">
    <div class="row justify-content-end">
      <div class="close-btn">
        <mat-icon (click)="closeClick()" svgIcon="close"></mat-icon>
        <div class="text">ESC</div>
      </div>
    </div>
    <div class="row justify-content-start" *ngIf="isForgot || showConfirmReset || showConfirmForgot || showError">
      <div class="back-btn">
        <mat-icon (click)="goBack()" svgIcon="left-arrow"></mat-icon>
      </div>
    </div>
    <div class="broker-modal-content" *ngIf="!showConfirmReset && !showConfirmForgot && !showError">
      <div class="broker-modal-title">{{ !isForgot ? titleUpdate : titleForgot  }}</div>
      <div class="broker-modal-subtitle">{{ !isForgot ? subTitleUpdate : subTitleSignature }}</div>
      <div class="broker-modal-email" *ngIf="isForgot">{{ email }} </div>
      <div class="snack-bar-msg">
        <div #error></div>
      </div>
      <form name="form" class="form" #brokerForm="ngForm" novalidate
        *ngIf="!isForgot && !showConfirmReset && !showConfirmForgot && !showError">
        <div>
          <mat-form-field class="userinput">
            <input [type]="showSignature ? 'text' : 'password'" matInput placeholder="assinatura eletrônica atual"
              autocomplete="signature" name="Signature" [(ngModel)]="model.signature" #signature="ngModel" required
              minlength="6" maxlength="6" (keypress)="validChar($event)" ondragstart="return false;"
              ondrop="return false;">
            <span *ngIf="model.signature && model.signature != ''" (click)="toggleSignature()" class="showHideSuffix"
              matSuffix>{{showSignature ? 'ocultar': 'mostrar'}}</span>
            <mat-hint align="end" class="mt-1">
            </mat-hint>
          </mat-form-field>
        </div>
        <div class="forgot-signature">
          <div class="error-msg">
            <mat-error class="error-msg" *ngIf="signature.touched && signature.value.length < 6">Informe pelo menos 06
              números.
            </mat-error>
          </div>
          <div class="forgot">
            <span (click)="forgotSignature()">esqueci minha assinatura eletrônica</span>
          </div>
        </div>
        <mat-form-field class="userinput">
          <input (keyup)="validatorSignature()" [type]="showNewSignature ? 'text' : 'password'" matInput
            placeholder="nova assinatura eletrônica" autocomplete="new-signature" name="newSignature"
            [(ngModel)]="model.newSignature" #newSignature="ngModel" required minlength="6" maxlength="6"
            (keypress)="validChar($event)" ondragstart="return false;" ondrop="return false;">
          <span *ngIf="model.newSignature && model.newSignature != ''" (click)="toggleNewSignature()"
            class="showHideSuffix" matSuffix>{{showNewSignature ? 'ocultar': 'mostrar'}}</span>
          <mat-hint align="end" class="mt-1">
          </mat-hint>
          <mat-error *ngIf="newSignature.touched && newSignature.value.length < 6">
            Informe pelo menos 06 números.
          </mat-error>
        </mat-form-field>
        <mat-form-field class="userinput">
          <input (keyup)="validatorSignature()" [type]="showConfirmSignature ? 'text' : 'password'" matInput
            placeholder="confirmação de nova assinatura eletrônica" autocomplete="confirm-signature"
            name="confirmSignature" [(ngModel)]="model.confirmSignature" #confirmSignature="ngModel" required
            minlength="6" maxlength="6" (keypress)="validChar($event)" ondragstart="return false;"
            ondrop="return false;">
          <span *ngIf="model.confirmSignature && model.confirmSignature != ''" (click)="toggleConfirmSignature()"
            class="showHideSuffix" matSuffix>{{showConfirmSignature ? 'ocultar': 'mostrar'}}</span>
          <mat-hint align="end" class="mt-1">
          </mat-hint>
          <mat-error *ngIf="confirmSignature.touched && confirmSignature.value.length < 6">
            Informe pelo menos 06 números.
          </mat-error>
        </mat-form-field>
        <div class="msg-error-one"
          *ngIf="(confirmSignature && confirmSignature.touched) && (newSignature && newSignature.touched) && !validSignature">
          <span class="message-error">{{ errorMsg01 }}</span>
        </div>
        <div class="button-submit">
          <div class="button-progress">
            <button [ngClass]="{ 'fadeIn': !loadingReset, 'fadeOut': loadingReset, 'error': brokerForm.form.invalid && brokerForm.touched && 
                newSignature.invalid && confirmSignature.invalid, 'success': !loadingReset && isUserLogged }"
              mat-raised-button color="primary01" class="animated" type="submit" (click)="changeSignature()"
              [disabled]="loadingReset || brokerForm.form.invalid || newSignature.invalid || confirmSignature.invalid || !validSignature">
              Alterar
            </button>
            <div id="spinnerDiv" *ngIf="!isUserLogged && loadingReset"
              [ngClass]="{ 'fadeIn': loading, 'fadeOut': !loading }" class="animated change-signature">
              <mat-spinner diameter="38" color="primary02"></mat-spinner>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="broker-modal-content" *ngIf="!isForgot && showConfirmReset && !showConfirmForgot && !showError">
      <div class="signature-success">
        <div class="img">
          <img src="./assets/images/svg/password-success.svg" width="115.1px" height="108.9px">
        </div>
        <div class="broker-modal-title title">Nova assinatura eletrônica cadastrada com sucesso!</div>
        <div class="broker-modal-title sub-title">Tudo pronto para começar a investir.</div>
      </div>
    </div>
    <div class="broker-modal-content" *ngIf="isForgot && !showConfirmReset && !showConfirmForgot && !showError">
      <div class="button-submit center">
        <div class="button-progress">
          <button
            [ngClass]="{ 'fadeIn': !loadingForgot, 'fadeOut': loadingForgot, 'success': !loadingForgot && isUserLogged }"
            mat-raised-button color="primary01" class="animated" type="submit"
            (click)="sendForgotSignature()">ENVIAR</button>
          <div id="spinnerDiv" *ngIf="!isUserLogged && loadingForgot"
            [ngClass]="{ 'fadeIn': loadingForgot, 'fadeOut': !loadingForgot }" class="animated forgot-signature">
            <mat-spinner diameter="38" color="primary02"></mat-spinner>
          </div>
        </div>
      </div>
    </div>
    <div class="broker-modal-content" *ngIf="isForgot && !showConfirmReset && showConfirmForgot && !showError">
      <div class="signature-success">
        <div class="broker-modal-title title">E-mail enviado com sucesso!</div>
        <div class="broker-modal-title sub-title">Um e-mail com link para recuperação de nova assinatura eletrônica foi
          enviado para seu e-mail! Caso não veja em sua caixa de entrada tente localiza-la em seu lixo eletrônico</div>
      </div>
      <div class="center">
        <img src="./assets/images/svg/send.svg" width="97.2px" height="97.2px">
      </div>
    </div>
    <div class="broker-modal-content" *ngIf="showError">
      <div class="error-forgot">
        <div class="recover-error"></div>
        <div class="title-error">{{ titleError }}</div>
        <div class="content">{{ contentError }}</div>
        <div class="contact-error">
          <div *ngIf="helpPhone1 && helpPhone1.phoneNumber != ''" class="contact-whatsapp">
            <div class="block-box"><img *ngIf="helpPhone1.isWhatsApp" src="./assets/images/svg/whatsapp-logo.svg"
                style="width: 29px;"></div>
            <span class="block-box contact-link" (click)="openWhatsappWindow()">{{ helpPhone1.phoneNumber }}</span>
          </div>
          <div *ngIf="helpEmail != ''" class="contact-email">
            <div class="block-box"><img src="./assets/images/svg/email.svg" style="width: 29px;"></div>
            <a class="block-box contact-link" href="mailto:{{ helpEmail }}">{{ helpEmail }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>